import { UXCamConfig } from "../constants/UXCamConfig";

export function initializeUXCam(username: string) {
    window.UXCam.optIntoSchematicRecordings();
    window.UXCam.setUserIdentity(username);
    window.UXCam.startWithConfiguration(UXCamConfig);
}

export function uxCamTagScreen(screenName: string) {
    // Only present on native builds where the UXCam plugin has loaded; on web
    // and in tests this is a no-op.
    if (!window.UXCam) return;
    window.UXCam.tagScreenName(screenName);
}
